import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { bookmakerApi, bmErrorMessage, pickFormValues } from '@/api/bookmaker'
import { BmForm, BmPage } from './BmPage'

export function CreateHorsePage() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [values, setValues] = useState<Record<string, string>>({
    name: '', betfairId: '', marketId: '', selectionId: '',
    _id: id ?? '',
  })
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (!id) return
    void (async () => {
      setBusy(true)
      setError(null)
      try {
        const data = await bookmakerApi.horseGetOne({ _id: id, id })
        setValues((s) => ({
          ...s,
          ...pickFormValues(data, ['name', 'betfairId', 'marketId', 'selectionId']),
          _id: id,
        }))
      } catch (e) {
        setError(bmErrorMessage(e))
      } finally {
        setBusy(false)
      }
    })()
  }, [id])

  async function onSubmit() {
    setBusy(true)
    setError(null)
    try {
      const body: Record<string, unknown> = { ...values }
      if (id) body._id = id
      await id ? bookmakerApi.horseEdit(body) : bookmakerApi.horseCreate(body)
      navigate('/horselist')
    } catch (e) {
      setError(bmErrorMessage(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <BmPage title={id ? `Edit Horse` : `Create Horse`} description="Lab create/edit via Bookmaker-API" error={error}>
      <BmForm
        fields={[
    { key: 'name', label: 'Name' },
    { key: 'betfairId', label: 'Betfair Id' },
    { key: 'marketId', label: 'Market Id' },
    { key: 'selectionId', label: 'Selection Id' },
        ]}
        values={values}
        onChange={(k, v) => setValues((s) => ({ ...s, [k]: v }))}
        onSubmit={() => void onSubmit()}
        busy={busy}
        submitLabel={id ? 'Update' : 'Create'}
      />
    </BmPage>
  )
}
